import React from 'react';
import DemoBooking from './demo';
import './App.css';

function App() {
  return (
    <div className="App">
      <DemoBooking />
    </div>
  );
}

export default App;
